// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiAppeal {
    'available'?: string | null;
    'contactFax'?: string | null;
    'contactOrg'?: string | null;
    'contactPhone'?: string | null;
    'contactWebsite'?: string | null;
    'notificationMethod'?: string | null;
    'numberOfAppealsAvailable'?: string | null;
    'requiredDocuments'?: string | null;
    'submissionDeadline'?: string | null;
    'turnaroundTime'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiAppeal>> = [
        {
            "name":     "available",
            "baseName": "available",
            "type":     "string"
        },
        {
            "name":     "contactFax",
            "baseName": "contactFax",
            "type":     "string"
        },
        {
            "name":     "contactOrg",
            "baseName": "contactOrg",
            "type":     "string"
        },
        {
            "name":     "contactPhone",
            "baseName": "contactPhone",
            "type":     "string"
        },
        {
            "name":     "contactWebsite",
            "baseName": "contactWebsite",
            "type":     "string"
        },
        {
            "name":     "notificationMethod",
            "baseName": "notificationMethod",
            "type":     "string"
        },
        {
            "name":     "numberOfAppealsAvailable",
            "baseName": "numberOfAppealsAvailable",
            "type":     "string"
        },
        {
            "name":     "requiredDocuments",
            "baseName": "requiredDocuments",
            "type":     "string"
        },
        {
            "name":     "submissionDeadline",
            "baseName": "submissionDeadline",
            "type":     "string"
        },
        {
            "name":     "turnaroundTime",
            "baseName": "turnaroundTime",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiAppeal.attributeTypeMap;
    }
}
